<template>
  <Fragment>
    <span>
      {{ fornecedor | truncate(truncate) }}
    </span>
    <v-tooltip top>
      <template v-slot:activator="{ on }">
        <v-icon color="warning" v-if="!hasFornecedor" v-on="on" small>
          mdi-alert
        </v-icon>
      </template>
      <span>Fornecedor não encontrado na Proxpect</span>
    </v-tooltip>
    <div :class="cnpjClass">
      {{ cnpj | cnpj }}
    </div>
  </Fragment>
</template>

<script>
import { Fragment } from 'vue-frag';

export default {
  props: {
    notaFiscal: {
      type: Object,
      required: true,
    },
    cnpjClass: {
      type: String,
      default: 'caption',
    },
    truncate: {
      type: Number,
      default: 30,
    },
  },
  computed: {
    fornecedor() {
      return this.notaFiscal.fornecedor
        ? this.notaFiscal.fornecedor.pessoa.nome
        : this.notaFiscal.nomeEmitente;
    },
    cnpj() {
      return this.notaFiscal.fornecedor
        ? this.notaFiscal.fornecedor.pessoa.cnpj
        : this.notaFiscal.cnpjEmitente;
    },
    hasFornecedor() {
      return !!this.notaFiscal.fornecedor;
    },
  },
  components: {
    Fragment,
  },
};
</script>
